(function() {

    if (window.innerWidth < 1024) {
      initFullListings();
      initDoubleStyleBlock();
    }

  var mobileInit = false;
  var desktopInit = false;


  // Full Listings
  function initFullListings() {
    var fullListingSection = $( '.js-landing-full-listing-swiper--lpv2');
    fullListingSection.each(function(index){
        var $this = $(this);
        var nextFullListing = $this.parent().find( '.js-swiper-button--next' );
        var prevFullListing = $this.parent().find( '.js-swiper-button--prev' );
        var ls = $this.swiper( fullListingsConfig(nextFullListing, prevFullListing, $this));
        fullListingOnSlideChange(nextFullListing, prevFullListing, $this);
        window.addEventListener("resize", function(){
            var attr;
            var swiperConfig = fullListingsConfig(nextFullListing, prevFullListing, $this);
            for ( attr in swiperConfig ) if ( swiperConfig.hasOwnProperty( attr ) ) {
                ls.params[attr] = swiperConfig[attr];
            }
        });
    })
  }


function fullListingOnSlideChange(nextFullListing, prevFullListing, fullListingSwiper) {
  nextFullListing.toggleClass( 'disabled', !!fullListingSwiper.isBeginning );
  prevFullListing.toggleClass( 'disabled', !!fullListingSwiper.isEnd );
}

function fullListingsConfig(nextFullListing, prevFullListing, fullListingSwiper) {
  return ( window.innerWidth < 480 ) ? {
    grabCursor: true,
    loop: false,
    spaceBetween: 24,
    slidesPerView: 'auto',
    freeMode: true,
    nextButton: nextFullListing,
          prevButton: prevFullListing,
    onSlideChangeStart: fullListingOnSlideChange(nextFullListing, prevFullListing, fullListingSwiper)
  } : ( window.innerWidth < 768 ) ? {
    slidesPerView: 'auto',
    grabCursor: true,
    loop: false,
    freeMode: true,
    spaceBetween: 24,
    nextButton: nextFullListing,
          prevButton: prevFullListing,
    onSlideChangeStart: fullListingOnSlideChange(nextFullListing, prevFullListing, fullListingSwiper)
  } : ( window.innerWidth < 940 ) ? {
    slidesPerView: 'auto',
    spaceBetween: 24,
    freeMode: true,
    nextButton: nextFullListing,
          prevButton: prevFullListing,
    onSlideChangeStart: fullListingOnSlideChange(nextFullListing, prevFullListing, fullListingSwiper)
  } : ( window.innerWidth < 1024 ) ? {
    slidesPerView: 'auto',
    grabCursor: false,
    loop: false,
    spaceBetween: 24,
    freeMode: true,
    nextButton: nextFullListing,
          prevButton: prevFullListing,
    onSlideChangeStart: fullListingOnSlideChange(nextFullListing, prevFullListing, fullListingSwiper)
  }
  : {
    slidesPerView: 4,
    grabCursor: false,
    loop: false,
    spaceBetween: 24,
    freeMode: true,
    nextButton: nextFullListing,
          prevButton: prevFullListing,
    onSlideChangeStart: fullListingOnSlideChange(nextFullListing, prevFullListing, fullListingSwiper)
  };
}
// Listings Slider
$(window).resize(function(){
  if (window.innerWidth < 1024 && !mobileInit) {
    initFullListings();
    initDoubleStyleBlock();
    mobileInit = true;
    desktopInit = false;
  }
  else if (window.innerWidth > 1024 && !desktopInit) {
    $('.sector--remove-desktop-slider').find('.swiper-slide').removeAttr("style");
    desktopInit = true;
    mobileInit = false;
  }
});

// Double category block
function initDoubleStyleBlock() {
  var doubleStyleSection = $( '.js-style-double-block-swiper--lpv2' );
  doubleStyleSection.each(function(index){
      var $this = $(this);
      var nextStyle = $this.parent().find( '.js-swiper-button--next' );
      var prevStyle = $this.parent().find( '.js-swiper-button--prev' );
      var ls = $this.swiper( doubleStyleConfig(nextStyle, prevStyle, $this) );
      doubleStyleSectionOnSlideChange(nextStyle, prevStyle, $this);
      window.addEventListener("resize", function(){
          var attr;
          var swiperConfig = doubleStyleConfig(nextStyle, prevStyle, $this);
          for ( attr in swiperConfig ) if ( swiperConfig.hasOwnProperty( attr ) ) {
              ls.params[attr] = swiperConfig[attr];
          }
      });
  })
}


  function doubleStyleSectionOnSlideChange(nextStyle, prevStyle, fullListingSwiper) {
  nextStyle.toggleClass( 'disabled', !!fullListingSwiper.isBeginning );
  prevStyle.toggleClass( 'disabled', !!fullListingSwiper.isEnd );
  }

  function doubleStyleConfig(nextStyle, prevStyle, fullListingSwiper) {
  return ( window.innerWidth < 480 ) ? {
    grabCursor: true,
    loop: false,
    spaceBetween: 24,
    slidesPerView: 'auto',
    freeMode: true,
    nextButton: nextStyle,
          prevButton: prevStyle,
    onSlideChangeStart: doubleStyleSectionOnSlideChange(nextStyle, prevStyle, fullListingSwiper)
  } : ( window.innerWidth < 768 ) ? {
    slidesPerView: 'auto',
    grabCursor: true,
    loop: false,
    freeMode: true,
    spaceBetween: 24,
    nextButton: nextStyle,
          prevButton: prevStyle,
    onSlideChangeStart: doubleStyleSectionOnSlideChange(nextStyle, prevStyle, fullListingSwiper)
  } : ( window.innerWidth < 940 ) ? {
    slidesPerView: 'auto',
    spaceBetween: 24,
    freeMode: true,
    nextButton: nextStyle,
          prevButton: prevStyle,
    onSlideChangeStart: doubleStyleSectionOnSlideChange(nextStyle, prevStyle, fullListingSwiper)
  } : ( window.innerWidth < 1168 ) ? {
    slidesPerView: 'auto',
    grabCursor: false,
    loop: false,
    spaceBetween: 24,
    freeMode: true,
    nextButton: nextStyle,
          prevButton: prevStyle,
    onSlideChangeStart: doubleStyleSectionOnSlideChange(nextStyle, prevStyle, fullListingSwiper)
  } : (window.innerWidth < 1441) ? {
    slidesPerView: 'auto',
    slidesPerGroup: 4,
    grabCursor: false,
    loop: false,
    spaceBetween: 24,
    nextButton: nextStyle,
          prevButton: prevStyle,
    onSlideChangeStart: doubleStyleSectionOnSlideChange(nextStyle, prevStyle, fullListingSwiper)
  }	: {
    slidesPerView: 4,
    slidesPerGroup: 4,
    grabCursor: false,
    loop: false,
    spaceBetween: 24,
    nextButton: nextStyle,
          prevButton: prevStyle,
    onSlideChangeStart: doubleStyleSectionOnSlideChange(nextStyle, prevStyle, fullListingSwiper),
  };
  }



// Slider listing block slider
var listingSliderSection = $( '.js-landing-listing-swiper--lpv2' );
  listingSliderSection.each(function(index){
      var $this = $(this);
      var nextListingSlider = $this.parent().find( '.js-swiper-button--next' );
      var prevListingSlider = $this.parent().find( '.js-swiper-button--prev' );
      var fs = $this.swiper( listingSliderConfig(nextListingSlider, prevListingSlider, $this) );
      listingSliderOnSlideChange(nextListingSlider, prevListingSlider, $this);
      window.addEventListener("resize", function(){
          var attr;
          var swiperConfig = listingSliderConfig(nextListingSlider, prevListingSlider, $this);
          for ( attr in swiperConfig ) if ( swiperConfig.hasOwnProperty( attr ) ) {
              fs.params[attr] = swiperConfig[attr];
          }
      });
  })

function listingSliderOnSlideChange(nextListingSlider, prevListingSlider, listingSliderSwiper) {
  prevListingSlider.toggleClass( 'disabled', !!listingSliderSwiper.isBeginning );
  nextListingSlider.toggleClass( 'disabled', !!listingSliderSwiper.isEnd );
}

function listingSliderConfig(nextListingSlider, prevListingSlider, listingSliderSwiper) {
  return ( window.innerWidth < 480 ) ? {
    grabCursor: true,
    loop: false,
    spaceBetween: 24,
    slidesPerView: 'auto',
    freeMode: true,
    nextButton: nextListingSlider,
          prevButton: prevListingSlider,
    onSlideChangeStart: listingSliderOnSlideChange(nextListingSlider, prevListingSlider, listingSliderSwiper)
  } : ( window.innerWidth < 768 ) ? {
    slidesPerView: 'auto',
    freeMode: true,
    spaceBetween: 24,
    nextButton: nextListingSlider,
          prevButton: prevListingSlider,
    onSlideChangeStart: listingSliderOnSlideChange(nextListingSlider, prevListingSlider, listingSliderSwiper)
  } : ( window.innerWidth < 940 ) ? {
    slidesPerView: 'auto',
    spaceBetween: 24,
    freeMode: true,
    nextButton: nextListingSlider,
          prevButton: prevListingSlider,
    onSlideChangeStart: listingSliderOnSlideChange(nextListingSlider, prevListingSlider, listingSliderSwiper)
  } : ( window.innerWidth < 1168 ) ? {
    slidesPerView: 'auto',
    grabCursor: false,
    loop: false,
    spaceBetween: 24,
    freeMode: true,
    nextButton: nextListingSlider,
          prevButton: prevListingSlider,
    onSlideChangeStart: listingSliderOnSlideChange(nextListingSlider, prevListingSlider, listingSliderSwiper)
  } : (window.innerWidth < 1441) ? {
    slidesPerView: 4,
    slidesPerGroup: 4,
    grabCursor: false,
    loop: false,
    spaceBetween: 24,
    nextButton: nextListingSlider,
          prevButton: prevListingSlider,
    onSlideChangeStart: listingSliderOnSlideChange(nextListingSlider, prevListingSlider, listingSliderSwiper)
}	: {
    slidesPerView: 4,
    slidesPerGroup: 4,
    grabCursor: false,
    loop: false,
    spaceBetween: 24,
    nextButton: nextListingSlider,
          prevButton: prevListingSlider,
    onSlideChangeStart: listingSliderOnSlideChange(nextListingSlider, prevListingSlider, listingSliderSwiper)
  };
}


	// Full Destination Slider
	var fullDestinationSection = $( '.js-landing-fulldestination-swiper--lpv2' );
    fullDestinationSection.each(function(index){
        var $this = $(this);
        var nextFullDestination = $this.parent().find( '.js-swiper-button--next' );
        var prevFullDestination = $this.parent().find( '.js-swiper-button--prev' );
        var fs = $this.swiper( fullDestinationsConfig(nextFullDestination, prevFullDestination, $this) );
        fullDestinationOnSlideChange(nextFullDestination, prevFullDestination, $this);
        window.addEventListener("resize", function(){
            var attr;
            var swiperConfig = fullDestinationsConfig(nextFullDestination, prevFullDestination, $this);
            for ( attr in swiperConfig ) if ( swiperConfig.hasOwnProperty( attr ) ) {
                fs.params[attr] = swiperConfig[attr];
            }
        });
    })

	function fullDestinationOnSlideChange(nextFullDestination, prevFullDestination, fullDestinationSwiper) {
    prevFullDestination.toggleClass( 'disabled', !!fullDestinationSwiper.isBeginning );
		nextFullDestination.toggleClass( 'disabled', !!fullDestinationSwiper.isEnd );
	}

	function fullDestinationsConfig(nextFullDestination, prevFullDestination, fullDestinationSwiper) {
    var totalSlides = fullDestinationSwiper.find('.swiper-slide').length; // Get the number of slides
    var slidesPerViewSetting = totalSlides > 3 && window.innerWidth > 1215 ? 3.5 : 3; // Set 3.5 if more than 3 slides, otherwise 3
    var paginationSetting = totalSlides > 3 ? '.js-swiper-pagination--lpv2' : '';

		return ( window.innerWidth < 480 ) ? {
			grabCursor: true,
			loop: false,
			spaceBetween: 24,
      slidesPerView: 'auto',
      freeMode: true,
      pagination: paginationSetting,
			nextButton: nextFullDestination,
            prevButton: prevFullDestination,
			onSlideChangeStart: fullDestinationOnSlideChange(nextFullDestination, prevFullDestination, fullDestinationSwiper)
		} : ( window.innerWidth < 768 ) ? {
			slidesPerView: 'auto',
      freeMode: true,
      pagination: paginationSetting,
      spaceBetween: 24,
			nextButton: nextFullDestination,
            prevButton: prevFullDestination,
			onSlideChangeStart: fullDestinationOnSlideChange(nextFullDestination, prevFullDestination, fullDestinationSwiper)
		} : ( window.innerWidth < 940 ) ? {
			slidesPerView: 'auto',
      spaceBetween: 24,
      pagination: paginationSetting,
      freeMode: true,
			nextButton: nextFullDestination,
            prevButton: prevFullDestination,
			onSlideChangeStart: fullDestinationOnSlideChange(nextFullDestination, prevFullDestination, fullDestinationSwiper)
		} : ( window.innerWidth < 1168 ) ? {
			slidesPerView: 'auto',
			grabCursor: false,
			loop: false,
			spaceBetween: 24,
      pagination: paginationSetting,
      freeMode: true,
			nextButton: nextFullDestination,
            prevButton: prevFullDestination,
			onSlideChangeStart: fullDestinationOnSlideChange(nextFullDestination, prevFullDestination, fullDestinationSwiper)
		} : (window.innerWidth < 1441) ? {
      pagination: paginationSetting,
			slidesPerView: slidesPerViewSetting,
			slidesPerGroup: 3,
			grabCursor: false,
			loop: false,
			spaceBetween: 24,
			nextButton: nextFullDestination,
            prevButton: prevFullDestination,
			onSlideChangeStart: fullDestinationOnSlideChange(nextFullDestination, prevFullDestination, fullDestinationSwiper)
	}	: {
			slidesPerView: slidesPerViewSetting,
      pagination: paginationSetting,
			slidesPerGroup: 3,
			grabCursor: false,
			loop: false,
			spaceBetween: 24,
			nextButton: nextFullDestination,
      prevButton: prevFullDestination,
			onSlideChangeStart: fullDestinationOnSlideChange(nextFullDestination, prevFullDestination, fullDestinationSwiper)
		};
	}

  // Full Destination Slider
  var	stylesSection = $( '.js-landing-listing-style-swiper--lpv2' );
    stylesSection.each(function(index){
        var $this = $(this);
        var nextStyle = $this.parent().find( '.js-swiper-button--next' );
        var prevStyle = $this.parent().find( '.js-swiper-button--prev' );
        var fs = $this.swiper( stylesConfig(nextStyle, prevStyle, $this) );
        stylesOnSlideChange(nextStyle, prevStyle, $this);
        window.addEventListener("resize", function(){
            var attr;
            var swiperConfig = stylesConfig(nextStyle, prevStyle, $this);
            for ( attr in swiperConfig ) if ( swiperConfig.hasOwnProperty( attr ) ) {
                fs.params[attr] = swiperConfig[attr];
            }
        });
    })

	function stylesOnSlideChange(prevStyle, nextStyle, stylesSectionSwiper) {
		prevStyle.toggleClass( 'disabled', !!stylesSectionSwiper.isBeginning );
		nextStyle.toggleClass( 'disabled', !!stylesSectionSwiper.isEnd );
	}

	function stylesConfig(nextStyle, prevStyle, stylesSectionSwiper) {
		return ( window.innerWidth < 480 ) ? {
      grabCursor: true,
			loop: false,
			spaceBetween: 24,
      slidesPerView: 'auto',
      freeMode: true,
			nextButton: nextStyle,
            prevButton: prevStyle,
			onSlideChangeStart: stylesOnSlideChange(prevStyle, nextStyle, stylesSectionSwiper)
		} : ( window.innerWidth < 768 ) ? {
      slidesPerView: 'auto',
      freeMode: true,
      spaceBetween: 24,
			nextButton: nextStyle,
            prevButton: prevStyle,
			onSlideChangeStart: stylesOnSlideChange(prevStyle, nextStyle, stylesSectionSwiper)
		} : ( window.innerWidth < 940 ) ? {
			slidesPerView: 'auto',
      spaceBetween: 24,
      freeMode: true,
			nextButton: nextStyle,
            prevButton: prevStyle,
			onSlideChangeStart: stylesOnSlideChange(prevStyle, nextStyle, stylesSectionSwiper)
		} : ( window.innerWidth < 1168 ) ? {
      slidesPerView: 'auto',
      grabCursor: false,
      loop: false,
      spaceBetween: 24,
      freeMode: true,
			nextButton: nextStyle,
            prevButton: prevStyle,
			onSlideChangeStart: stylesOnSlideChange(prevStyle, nextStyle, stylesSectionSwiper)
		} : (window.innerWidth < 1441) ? {
      slidesPerView: 4,
			slidesPerGroup: 4,
			grabCursor: false,
			loop: false,
			spaceBetween: 24,
			nextButton: nextStyle,
			prevButton: prevStyle,
			onSlideChangeStart: stylesOnSlideChange(prevStyle, nextStyle, stylesSectionSwiper)
		} :  {
      slidesPerView: 4,
			slidesPerGroup: 4,
			grabCursor: false,
			loop: false,
			spaceBetween: 24,
			nextButton: nextStyle,
            prevButton: prevStyle,
			onSlideChangeStart: stylesOnSlideChange(prevStyle, nextStyle, stylesSectionSwiper)
		};
	}

	// Category Slider
	var	categoriesSection = $( '#listing-categories' ),
		nextCategory = categoriesSection.find( '.js-swiper-button--next' ),
		prevCategory = categoriesSection.find( '.js-swiper-button--prev' ),
		categorySwiper = new Swiper( '.js-landing-listing-category-swiper', categoriesConfig() );
	categoryOnSlideChange();
	window.addEventListener("resize", function(){
		var attr,
			swiperConfig = categoriesConfig();
		for ( attr in swiperConfig ) if ( swiperConfig.hasOwnProperty( attr ) ) {
			categorySwiper.params[ attr ] = swiperConfig[ attr ];
		}
	});

	function categoryOnSlideChange() {
		prevCategory.toggleClass( 'disabled', !!categorySwiper.isBeginning );
		nextCategory.toggleClass( 'disabled', !!categorySwiper.isEnd );
	}

	function categoriesConfig() {
		return ( window.innerWidth < 768 ) ? {
			slidesPerView: 'auto',
			slidesPerGroup: 1,
			grabCursor: true,
			loop: false,
			spaceBetween: 8,
			nextButton: nextCategory,
            prevButton: prevCategory,
			onSlideChangeStart: categoryOnSlideChange
		} : ( window.innerWidth < 1168 ) ? {
			slidesPerView: 'auto',
			slidesPerGroup: 1,
			grabCursor: false,
			loop: false,
			spaceBetween: 8,
			nextButton: nextCategory,
            prevButton: prevCategory,
			onSlideChangeStart: categoryOnSlideChange
		} : (window.innerWidth < 1441) ? {
			slidesPerView: 4,
			slidesPerGroup: 2,
			grabCursor: false,
			loop: false,
			spaceBetween: 16,
			nextButton: nextCategory,
			prevButton: prevCategory,
			onSlideChangeStart: categoryOnSlideChange
		} : {
			slidesPerView: 4,
			slidesPerGroup: 2,
			grabCursor: false,
			loop: false,
			spaceBetween: 16,
			nextButton: nextCategory,
            prevButton: prevCategory,
			onSlideChangeStart: categoryOnSlideChange
		};
	}
  $(".swiper-button--lpv2").addClass('loaded');
})();


// CSS & JS sliders
let isDown = false;
let isDragging = false;
let startX, scrollLeft;

const scrollContainers = document.querySelectorAll('.landing-scrollable-container');

const isDesktop = () => window.matchMedia('(min-width: 768px)').matches;

scrollContainers.forEach(scrollContainer => {
  if (!isDesktop()) return;

  const leftArrow = document.createElement('div');
  leftArrow.className = 'scroll-arrow left-arrow';
  leftArrow.innerHTML = '&#8249;';
  leftArrow.style.display = 'none';

  const rightArrow = document.createElement('div');
  rightArrow.className = 'scroll-arrow right-arrow';
  rightArrow.innerHTML = '&#8250;';

  scrollContainer.parentElement.append(leftArrow, rightArrow);

  const updateArrows = () => {
    const scrollLeft = scrollContainer.scrollLeft;
    const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;

    leftArrow.style.display = scrollLeft > 0 ? 'flex' : 'none';
    rightArrow.style.display = scrollLeft < maxScrollLeft ? 'flex' : 'none';
  };

  updateArrows();

  leftArrow.addEventListener('click', () => {
    scrollContainer.scrollBy({ left: -300, behavior: 'smooth' });
  });

  rightArrow.addEventListener('click', () => {
    scrollContainer.scrollBy({ left: 300, behavior: 'smooth' });
  });

  scrollContainer.addEventListener('scroll', updateArrows);

  scrollContainer.addEventListener('mousedown', (e) => {
    isDown = true;
    isDragging = false;
    scrollContainer.classList.add('active');
    startX = e.pageX - scrollContainer.offsetLeft;
    scrollLeft = scrollContainer.scrollLeft;
    e.preventDefault();
  });

  scrollContainer.addEventListener('mouseleave', () => {
    isDown = false;
    scrollContainer.classList.remove('active');
  });

  scrollContainer.addEventListener('mouseup', () => {
    isDown = false;
    scrollContainer.classList.remove('active');
  });

  scrollContainer.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - scrollContainer.offsetLeft;
    const walk = (x - startX) * 2;

    if (Math.abs(walk) > 5) {
      isDragging = true;
    }

    scrollContainer.scrollLeft = scrollLeft - walk;
  });

  scrollContainer.addEventListener('click', (e) => {
    if (isDragging) {
      e.preventDefault();
    }
  });
});

